import { useEffect, useState } from 'react';

/**
 * The current time, refreshed every `intervalMs`, so wording such as
 * "5 minutes ago" or "Ends today" stays true on a screen left open all day.
 * Nothing else would re-render it: a poll that brings back the same data
 * leaves the page as it was.
 */
export function useNow(intervalMs: number): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(timer);
  }, [intervalMs]);

  return now;
}
